module.exports = __webpack_public_path__ + "img/post.0610ab18.jpg";